export default "__VITE_ASSET__29a86648__"